import { render, staticRenderFns } from "./card-product-selector.vue?vue&type=template&id=4c02254a&"
import script from "./card-product-selector.vue?vue&type=script&lang=js&"
export * from "./card-product-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports